import type { TRouteMatcher } from './models';

/** Дефолтный сопоставитель роута */
export const defaultMatcher: TRouteMatcher = ({ invert, name, route }) => {
    const isMatched = Array.isArray(name) ? name.includes(route) : route === name;

    return invert ? !isMatched : isMatched;
};
